import { createTheme } from '@mui/material/styles';

import { baseTheme, getCommonThemesProps } from './baseTheme';
import { bfacmColors } from './colors';

export const themeBFACM = () => {
  const theme = baseTheme();

  const themeProperties = getCommonThemesProps(bfacmColors);
  const { palette, components } = themeProperties;

  return createTheme({
    breakpoints: theme.breakpoints,
    palette,
    components,
    customLogo: {
      logo: 'BFACM_LOGO',
      slogo: 'BFACM_SLOGO',
      nlogo: 'BFACM_LOGO',
      clogo: 'BFACM_LOGO',
    },
    verticalBreakpoints: theme.verticalBreakpoints,
    typography: theme.typography,
  });
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  window.theme = themeBFACM();
}
